angular.module('impactx.tax').controller('CC2TaxEventListCtrl', [
    'selectedListItems',
    'dataGen',
    'ConfirmationService',
    'ToastService',
    'TranslationService',
    '$redirect',
    CC2TaxEventListCtrl
]);

function CC2TaxEventListCtrl(selectedListItems, dataGen, ConfirmationService, ToastService, TranslationService, $redirect) {
    var self = this;

    function deleteFunction (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {rows: selectedListItems.getSelectedItems()}, '/tax/cc2taxevent/delete').then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.reload();
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    function canDelete () {
        return selectedListItems.checkEach(function (item) {
            return item.canDelete.value;
        })
    }

    var buttonDefinition = [
        {
            label: "delete",
            action: deleteFunction,
            condition: canDelete,
            process: 'EditTaxes'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/tax/templates/cc2taxeventlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/tax/cc2taxevent/list',
        id: "TaxEventList",
        excelExport: true,
        buttonDefinition: buttonDefinition,
        mainAction: {id: "new", link: "#/cc2taxevent", icon: "mdi-plus"}
    };
    self.getMeta = function () {
        return self.meta;
    };
}